/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DashboardLxComponentSummary = {
    id?: (string | null);
    component_type: DashboardLxComponentSummary.component_type;
    name?: (string | null);
    expression?: (string | null);
    namespace_id?: (string | null);
    return_type?: (string | null);
    aggregate?: (string | null);
};

export namespace DashboardLxComponentSummary {

    export enum component_type {
        ATTRIBUTE = 'attribute',
        FILTER = 'filter',
        GROUP = 'group',
        ORDER = 'order',
    }


}

